import React from 'react'
import { cn } from '../../../../lib/utils'
import { ScrollArea } from '../../../../components/ui/scroll-area'

interface AppSidebarProps {
  className?: string
  header?: React.ReactNode
  footer?: React.ReactNode
  children?: React.ReactNode
}

export function AppSidebar({ className, header, footer, children }: AppSidebarProps) {
  return (
    <div className={cn('flex flex-col h-screen w-64 border-r bg-muted/10 text-foreground shrink-0', className)}>
      <div className="h-14 px-4 border-b flex items-center shrink-0">
        {header}
      </div>

      <ScrollArea className="flex-1 py-4">
        <div className="px-3 flex flex-col gap-1">
          {children}
        </div>
      </ScrollArea>

      {footer && (
        <div className="p-4 border-t shrink-0">
          {footer}
        </div>
      )}
    </div>
  )
}